// ④/A2 — رسائل المستلم الواحد في نوافذ «الإرسال»: القالب بالاسم العربي · الوقت KSA · حالة التسليم.
import React, { useState } from "react";
import { formatKSA } from "../lib/ksaTime";
import { arCount } from "../lib/arCount";

const STATUS_AR = { sent: "أُرسلت", delivered: "وصلت", read: "قُرئت", failed: "فشلت" };

export const TeamBadge = ({ testId }) => (
  <span data-testid={testId} style={{ marginInlineStart: 6, padding: "1px 7px", borderRadius: 999,
    background: "#E0F2FE", color: "#075985", fontSize: 10.5, fontWeight: 800 }}>فريق</span>
);

export function RecipientMessages({ messages, idx }) {
  const [open, setOpen] = useState(false);
  if (!messages || !messages.length) return null;
  return (
    <div style={{ marginTop: 4 }}>
      <button type="button" data-testid={`clm-messages-toggle-${idx}`} onClick={() => setOpen((v) => !v)}
        style={{ background: "none", border: "none", padding: 0, color: "#57534E", fontSize: 11, cursor: "pointer", textDecoration: "underline" }}>
        {arCount(messages.length, "message")} {open ? "▲" : "▼"}
      </button>
      {open && (
        <ul data-testid={`clm-messages-${idx}`} style={{ margin: "6px 0 0", padding: 0, listStyle: "none", fontSize: 11, fontWeight: 400 }}>
          {messages.map((m, j) => (
            <li key={j} data-testid={`clm-message-${idx}-${j}`} style={{ padding: "3px 0", borderTop: j ? "1px dashed rgba(61,42,28,0.12)" : "none" }}>
              <b>{m.template_label_ar || m.template_name || (m.kind === "text" ? "نص حر" : "—")}</b>
              {" · "}{formatKSA(m.ts)}{" · "}
              <span style={{ color: m.delivery_status === "failed" ? "#B91C1C" : "#166534" }}>
                {STATUS_AR[m.delivery_status] || m.delivery_status}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
